import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------
// Shared design-system primitives for the Profile area
// (YYNY.AI / Veilstaff). Card surfaces and section headers used by
// UploadAvatar, UserForm and the Profile page so they read as one system.
// ----------------------------------------------------------------------

// Card surface: 16px radius, hairline border, resting z1 shadow.
export const panelSx = (t: Theme) => ({
  borderRadius: `${t.shape.borderRadiusMd}px`,
  border: `1px solid ${t.palette.grey[300]}`,
  boxShadow: t.customShadows.z1,
  bgcolor: 'background.paper',
});

// Section heading: sentence-case 18/28 SemiBold title with optional caption.
export const SectionHeader = ({
  title,
  caption
}: {
  title: ReactNode;
  caption?: ReactNode;
}) => (
  <Stack spacing={0.5} sx={{ mb: { xs: 3, sm: 4 } }}>
    <Typography
      component="h2"
      sx={{ fontSize: 18, lineHeight: '28px', fontWeight: 600, color: 'text.primary' }}
    >
      {title}
    </Typography>
    {caption ? (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {caption}
      </Typography>
    ) : null}
  </Stack>
);
